var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ngTranslate from 'angular-translate';
import { NgModule } from 'angular-ts-decorators';
import uiBootStrap from 'angular-ui-bootstrap';
import { AdminSettingsModule } from '../admin-settings/admin-settings.module';
import { AuthModule } from '../auth/auth.module';
import { EmailInboxConnectionModule } from '../email-inbox-connection/email-inbox-connection.module';
import { OrganizationModule } from '../organization/organization.module';
import { QuestionnaireModule } from '../questionnaire/questionnaire.module';
import { UserModule } from '../user/user.module';
let AppModule = class AppModule {
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$interpolateProvider', '$locationProvider', '$translateProvider'];
    static config($interpolateProvider, $locationProvider, $translateProvider) {
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $interpolateProvider.startSymbol('{[{');
        $interpolateProvider.endSymbol('}]}');
        $locationProvider.html5Mode({
            enabled: true,
            rewriteLinks: false,
        });
    }
};
AppModule = __decorate([
    NgModule({
        id: 'snapaddyAnalytics',
        imports: [
            ngTranslate,
            uiBootStrap,
            AdminSettingsModule,
            AuthModule,
            EmailInboxConnectionModule,
            OrganizationModule,
            UserModule,
            QuestionnaireModule,
        ],
        declarations: [],
        bootstrap: [],
    })
], AppModule);
export { AppModule };
